import { configureStore } from '@reduxjs/toolkit';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { usePageMeta } from 'shared/mechanics/page-meta';

import { ScreenerLayoutComponent } from './components/ScreenerLayoutComponent';

import { ScreenerStore } from './redux/model';
import { ScreenerStoreReducer } from './redux/reducers';
import { rootSaga } from './redux/sagas/root';

const sagaMiddleware = createSagaMiddleware();
export const screenerStore = configureStore<ScreenerStore>({
	reducer: ScreenerStoreReducer,
	middleware: [sagaMiddleware]
});

export const ScreenerPage = () => {
	usePageMeta({
		title: 'Скринер ETF - найди лучший ПИФ для инвестора',
		description: 'Сравнение биржевых инвестиционных фондов по доходности, составу, капитализации, классу, риску, индексу, котировкам и прочим параметрам',
		keyWords: ['пиф', 'etf', 'finex', 'паевой фонд', 'лист', 'фонд фондов', 'moex', 'ММВБ', 'российские ETF'],
		canonicalPath: 'screener' });


	useEffect(() => { sagaMiddleware.run(rootSaga) }, []);

	return (
		<Provider store={screenerStore}>
			<ScreenerLayoutComponent />
		</Provider>
	)
}